const {LitElement, html, repeat, ref, createRef, ifDefined, nothing, unsafeHTML } = window.globalLit;

import  { getTodayYmd, money, objectToFormData, setLoading, swalAlert } from '../functions.js';


export default class NewSelectorElement extends LitElement {
    
    static properties = {
        bookUrl:                  { type: String },
        pack:                     { type: Object },
        slots:                    { type: Array },
        csrfToken:                { type: String },
        selectedPackVariantCode:  { type: String },
        i18n:                     { type: Object },
        enableWaitingList:        { type: Boolean },

        selectedDate :      { type: String, state: true },
        selectedDateSlots : { type: Array, state: true },
        selectedSlot :      { type: Object, state: true },
        totalGuests  :  { type: Number, state: true },
    };

    createRenderRoot() { return this; }

    constructor() {
        super();
        this.selectedDateSlots = [];
        this.totalGuests = 1;
    }

    firstUpdated() {
        this.addEventListener('datechange', this.#onDateChange.bind(this));

        this.totalGuests = this.pack.guests_included_in_price || 1;

    }

    #onDateChange(event) {
        let dateYmd = event.detail;
        this.selectedDate = dateYmd;
        this.selectedDateSlots = this.#getAllSlotsForDate();

        if (this.selectedDateSlots.length === 1) {
            this.selectedSlot = this.selectedDateSlots[0];
        } else {
            this.selectedSlot = null;
        }

    }

    #getSlotsForSelectedVariant() {
        if (!this.selectedPackVariantCode) {
            return this.slots;
        }

        return this.slots.filter(slot => {
            if (slot.allowed_pack_variants.includes(this.pack.code + '.*')) {
                return true;
            }

            if (slot.allowed_pack_variants.includes(this.pack.code + '.' + this.selectedPackVariantCode)) {
                return true;
            }
            return false;
        });
    }

    #getAllSlotsForDate() {
        return this.#getSlotsForSelectedVariant().filter(slot => {
            return slot.slot_date === this.selectedDate;
        });
    }

    #getTimeSelectOptions() {
        let options = this.selectedDateSlots.map(slot => {
            let label = slot.slot_time;
            let hasWaitingList = slot.available_for_context <= 0;
            if (hasWaitingList) {
                label += ' - ' + this.i18n['Waiting list'];
            }
            return {
                value: slot.id,
                label: label
            };
        });

        return options;
    }

    #onSlotChange(event) {
        let id = parseInt(event.target.value, 10);

        this.selectedSlot = this.slots.find(slot => {
            return slot.id === id;
        });

    }

    #onRegisterClick() {
        customElements.whenDefined('waitinglist-form').then(() => {
            window.waitinglist1.show(this.selectedSlot.id);
        });
    }

    #onBookClick() {

        setLoading(this, true);

        let url = this.bookUrl;

        let selectedVariant = this.#getSelectedVariant();

        let data = {
            _csrfToken:         this.csrfToken,
            pack_id:            this.pack.id,
            slot_id:            this.selectedSlot.id,
            total_guests:       this.totalGuests,
            pack_variant_id:    selectedVariant?.id,
        };

        fetch(url, {
            method: 'POST',
            body: objectToFormData(data)
        })
        .then(res => res.json())
        .then(res => {
            setLoading(this, false);

            if (res.result === 1) {
                mySelectionButton1.click();
            } else {
                swalAlert(res.msg);
            }
            
        }).catch(err => {
            setLoading(this, false);
            console.error(err);
        });
    
    }

    #getSelectedVariant() {
        if (!this.selectedPackVariantCode) {
            return null;
        }
        
        let variant = this.pack.pack_variants.find(v => v.code === this.selectedPackVariantCode);

        return variant;
    }

    #getTitle() {
        let variant = this.#getSelectedVariant();
        if (variant) {
            return variant.name;
        }

        return this.pack.name;
    }

    #onGuestsChange(event) {
        this.totalGuests = event.detail;
    }

    render() {

        let timesOptions = this.#getTimeSelectOptions();

        let showWaitingList = this.enableWaitingList && this.selectedSlot && this.selectedSlot.available_for_context <= 0;

        let bookButtonEnabled = this.selectedSlot;

        let slots = this.#getSlotsForSelectedVariant();

        let haveFutureSlots = slots.some(slot => {
            return slot.slot_date >= getTodayYmd();
        });

        if (!haveFutureSlots) {
            return nothing;
        }

        let __ = this.i18n;

        let packImage = nothing;

        if (this.pack.content && this.pack.content.card_image) {
            packImage = this.pack.content.card_image.url || this.pack.content.header_image.url;
        }

        return html`
            <div class="container" style="padding-top: 2em; padding-bottom: 2em;">
                <div class="selector">

                    <input type="hidden" name="_csrfToken" value="${this.csrfToken}">

                    <input type="hidden" name="pack_code" value="${this.pack.code}"/>
                    <input type="hidden" name="pack_id" value="${this.pack.id}"/>

                    <conditional-render>
                        <div class="selector__wrapper">
                            <div class="selector__col is-first">

                                <div class="visible-mobile">
                                    <div class="selector__title stdtitle4">
                                        ${this.#getTitle()}
                                    </div>

                                    <selector-price 
                                        .price=${this.pack.price}
                                        .guestsIncludedInPrice=${this.pack.guests_included_in_price}
                                        .additionalGuestPrice=${this.pack.additional_guest_price}
                                        .totalGuests=${this.totalGuests}
                                        .i18n=${this.i18n}
                                        style="display:block;"></selector-price>

                                </div>

                                <calendar-element 
                                    class="calendar" 
                                    slots=${JSON.stringify(slots)}
                                    data-preceding-days="${this.pack.preceding_days}" 
                                    data-following-days="${this.pack.following_days}">
                                    <input type="hidden" name="date" />
                                    <div class="calendar__actions">
                                        <a href="" class="js-clear" style="display:none;">${__['Clear']}</a>
                                        <a href="" class="js-soonest" style="display:none; margin-left: auto; margin-right: 10px;">${__['Soonest']}</a>
                                        <a href="" class="js-today" style="display:none;">${__['Today']}</a>
                                    </div>
                                </calendar-element>

                            </div>
                            <div class="selector__col is-last">
                                <form class="selector__container" onsubmit="return false;">

                                    ${  
                                        this.pack.type === window.CONSTANTS.Pack.TYPE_PACK ? html`
                                            <img class="selector__image" src="${packImage}">
                                        `: ''
                                    }

                                    <div class="selector__content">

                                        <div class="selector__packname stdtitle4 hidden-mobile">
                                            ${this.#getTitle()}
                                        </div>

                                        <div class="selector__times ${timesOptions && timesOptions.length > 1 ? '' : 'hidden'}">
                                            <div class="cselect">
                                                <select name="slot_id" class="cselect__input" data-empty-option-label="${__['Select time']}" @change=${this.#onSlotChange}>
                                                    <option value="">${__['Select time']}</option>
                                                    ${repeat(timesOptions, option => option.value, option => html`
                                                        <option value="${option.value}">${option.label}</option>
                                                    `)}
                                                </select>
                                            </div>
                                        </div>

                                        ${
                                            this.enableWaitingList && this.selectedSlot && this.selectedSlot.available_for_context <= 0 ? html`
                                                <div class="selector__waitinglist">
                                                    ${__['Waiting list']}
                                                </div>
                                            ` : nothing
                                        }

                                        <div class="hidden-mobile">
                                            <selector-price 
                                                .price=${this.pack.price}
                                                .guestsIncludedInPrice=${this.pack.guests_included_in_price}
                                                .additionalGuestPrice=${this.pack.additional_guest_price}
                                                .totalGuests=${this.totalGuests}
                                                .i18n=${this.i18n}
                                                style="display:block;"></selector-price>
                                        </div>

                                        ${
                                            this.pack.display_guests_selector ? html`
                                                <p class="selector__guests" style="color:#4A4F54; font-size: 14px; font-weight: 600;">
                                                    ${__['Total guests']}
                                                    
                                                    <number-element data-min="1" data-max="${this.pack.max_guests}" @change=${this.#onGuestsChange}>
                                                        <input type="hidden" name="total_guests" value="${this.pack.guests_included_in_price || 1}">
                                                    </number-element>
                                                </p>
                                        ` : html`
                                            <input type="hidden" name="total_guests" value="${this.pack.guests_included_in_price || 1}">
                                        `
                                        }

                                        <div class="selector__actions">
                                            ${
                                                !showWaitingList ? html`
                                                    <button class="button1" id="bookButton1" ?disabled=${!bookButtonEnabled} @click=${this.#onBookClick} >
                                                        ${unsafeHTML(window.SVG_ARROW)}
                                                        ${__['Book']}
                                                    </button>
                                                ` : nothing
                                            }

                                            ${
                                            showWaitingList ? html`
                                                <button class="button1" id="waitinglistButton1" @click=${this.#onRegisterClick}>
                                                    ${unsafeHTML(window.SVG_ARROW)}
                                                    ${__['Register']}
                                                </button>
                                                ` : nothing
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </conditional-render>

                
                </div>
            </div>
            `

    }


}
window.customElements.define('new-selector-element', NewSelectorElement);

window.customElements.define('selector-price', class extends LitElement {
    
    static properties = {
        totalGuests:            { type: Number },
        price:                  { type: Number },
        guestsIncludedInPrice:  { type: Number },
        additionalGuestPrice:   { type: Number },
        i18n:                   { type: Object },
    };

    createRenderRoot() { return this; }

    firstUpdated() {}

    getPrice() {
        return (
            parseFloat(this.price) 
            + 
            (
                this.getAdditionalGuests() * parseFloat(this.additionalGuestPrice)
            )
        );
    }

    getAdditionalGuests() {
        return Math.max(0, this.totalGuests - this.guestsIncludedInPrice);
    }

    render() {
        
        let __ = this.i18n;

        let price = parseFloat(this.price);

        if (price <= 0) {
            return nothing;
        }

        let pax = Math.max(this.guestsIncludedInPrice, this.totalGuests);

        let label;
        if (pax === 1) {
            label = __['price for 1 pax'];
        } else {
            label = __['price for {0} pax'].replace('{0}', pax);
        }


        return html`
            <p class="selector__desc">
                ${money(this.getPrice())}
                (${label})
            </p>
        `
    }


});

